import { DefaultFooter } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'Lịch Như Ý',
          title: `Lịch Như Ý ${dayjs().format('YYYY')}`,
          href: '',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
